import { useEffect } from 'react';
import './ui.css';

interface Props {
  kind: 'error' | 'info' | 'success';
  onDismiss: () => void;
  children: React.ReactNode;
  autoDismissMs?: number;
}

export function Toast({ kind, onDismiss, children, autoDismissMs = 6000 }: Props) {
  useEffect(() => {
    if (!autoDismissMs) return;
    const t = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(t);
  }, [autoDismissMs, onDismiss]);

  return (
    <div className={`toast toast-${kind}`} role="alert">
      <span className="toast-dot" />
      <div className="toast-body">{children}</div>
      <button className="toast-close" onClick={onDismiss} aria-label="Dismiss">x</button>
    </div>
  );
}

